import { onCleanup, onMount } from 'solid-js';
import { gameStore } from '@state/gameStore';
import {
  confirmPromotion,
  flipBoard,
  newGame,
  redo,
  selectSquare,
  undo,
} from '@state/actions';
import { shortcutTitle } from '@config/shortcuts';
import './GameControls.css';

export function GameControls(props: {
  onReset?: () => void;
  onUndo?: () => void;
  undoDisabled?: boolean;
}) {
  onMount(() => {
    const onKey = (e: KeyboardEvent) => {
      const t = e.target as HTMLElement | null;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) {
        return;
      }

      if (gameStore.pendingPromotion) {
        const k = e.key.toLowerCase();
        if (k === 'q' || k === 'r' || k === 'b' || k === 'n') {
          e.preventDefault();
          confirmPromotion(k);
          return;
        }
        return;
      }

      if (e.key === 'Escape') {
        e.preventDefault();
        selectSquare(null);
        return;
      }

      if (e.ctrlKey || e.metaKey || e.altKey) return;

      const k = e.key.toLowerCase();
      if (k === 'n') {
        e.preventDefault();
        if (props.onReset) props.onReset();
        else newGame();
      } else if (k === 'z' || e.key === 'ArrowLeft') {
        e.preventDefault();
        if (props.undoDisabled) return;
        if (props.onUndo) props.onUndo();
        else undo();
      } else if (k === 'y' || e.key === 'ArrowRight') {
        e.preventDefault();
        redo();
      } else if (k === 'f') {
        e.preventDefault();
        flipBoard();
      }
    };
    window.addEventListener('keydown', onKey);
    onCleanup(() => window.removeEventListener('keydown', onKey));
  });

  return (
    <div class="game-controls">
      <button
        type="button"
        class="btn"
        title={shortcutTitle('newGame')}
        onClick={() => (props.onReset ? props.onReset() : newGame())}
      >
        Reset
      </button>
      <button
        type="button"
        class="btn"
        title={shortcutTitle('undo')}
        onClick={() => (props.onUndo ? props.onUndo() : undo())}
        disabled={props.undoDisabled ?? gameStore.cursor <= 0}
      >
        Undo
      </button>
      <button
        type="button"
        class="btn"
        title={shortcutTitle('flip')}
        onClick={() => flipBoard()}
      >
        Flip
      </button>
    </div>
  );
}
